import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIEnablementSource, ReadingAidsPopupPropsInState } from '../../types';

export enum AIDefinitionsActionType {
	UPDATE_STATE = 'UPDATE_STATE',

	UPDATE_KEYWORD_REGEX = 'UPDATE_KEYWORD_REGEX',

	UPDATE_KEYWORD_DECORATIONS_SESSION_ID = 'UPDATE_KEYWORD_DECORATIONS_SESSION_ID',

	UPDATE_KEYWORD_DECORATIONS = 'UPDATE_KEYWORD_DECORATIONS',

	OPEN_READING_AIDS_POPUP = 'OPEN_READING_AIDS_POPUP',

	CLOSE_READING_AIDS_POPUP = 'CLOSE_READING_AIDS_POPUP',

	READING_AIDS_POPUP_LOADED = 'READING_AIDS_POPUP_LOADED',
}

interface UpdateState {
	type: AIDefinitionsActionType.UPDATE_STATE;
	enabled?: boolean;
	autoHighlightEnabled?: boolean;
	enablementSource?: AIEnablementSource;
}

interface UpdateKeywordRegex {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_REGEX;
	keywordRegex: RegExp;
}

interface UpdateSessionId {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS_SESSION_ID;
}

interface UpdateKeywordDecorations {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS;
	keywordDecorations: DecorationSet;
}

interface OpenReadingAidsPopup {
	type: AIDefinitionsActionType.OPEN_READING_AIDS_POPUP;
	// there will be keywordId if opened by clicking decoration, there will be no keywordId if opened by AI define button
	keywordId?: string;
	readingAidsPopupProps: ReadingAidsPopupPropsInState;
}

interface CloseReadingAidsPopup {
	type: AIDefinitionsActionType.CLOSE_READING_AIDS_POPUP;
}

interface ReadingAidsPopupLoaded {
	type: AIDefinitionsActionType.READING_AIDS_POPUP_LOADED;
}

export type AIDefinitionsAction =
	| UpdateState
	| UpdateKeywordRegex
	| UpdateSessionId
	| UpdateKeywordDecorations
	| OpenReadingAidsPopup
	| CloseReadingAidsPopup
	| ReadingAidsPopupLoaded;
